import React from 'react';

import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function CourseDestroyModal({
  currentTraining,
  deleteUserCourse,
  isOpen,
  setIsOpen,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.CourseDestroyModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const closeModalBox = () => {
    setIsOpen(false);
  };

  const handleDeleteClick = () => {
    closeModalBox();
    deleteUserCourse();
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={closeModalBox}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={handleDeleteClick}>
            {i18nT('button')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='letterbox'
      onClose={closeModalBox}
      usingStandardDimensions={true}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nTShared('deleteName', {
              interpolation: { escapeValue: false },
              name: currentTraining.course?.attributes.name,
            })}
          </h2>
        </div>
        <div className='modalbox-body'>{i18nT('description')}</div>
      </>
    </ModalBox>
  );
}
